import React from "react";

const ImageCard = ({ reverse, image, title, desc, white, className }) => {
  return (
    <div
      className={`flex w-full flex-col md:items-center justify-center gap-8 lg:gap-24
        ${reverse ? "lg:flex-row-reverse" : "lg:flex-row"} ${className}`}
    >
      <div className="md:max-w-132 space-y-4">
        <div
          className={`text-8 lg:text-5xl leading-tight header
            ${white ? "text-white" : "text-surface-100"}`}
        >
          {title}
        </div>
        <div
          className={`text-base lg:text-xl leading-relaxed 
            ${white ? "text-white" : "text-gray-dark"}`}
        >
          {desc}
        </div>
      </div>
      <div className="flex mx-auto max-w-[75vw] sm:max-w-md lg:max-w-2xl items-center justify-center">
        {image}
      </div>
    </div>
  );
};

export default ImageCard;
